export const ventasConsultivas45 = {
  slug: "ventas-consultivas-45",
  title: "Por qué el cliente deja de avanzar (aunque estaba interesado)",
  durationMin: 45,
  programType: "ejecutivo", // Tipo: editorial | ejecutivo
  
  // Campos de presentación UI
  tagline: "Ese punto donde el deal se enfría… casi nunca es obvio.",
  description: "3 conversaciones cortas que desarman cómo se toman decisiones en ventas B2B.\nBasado en Influence, SPIN Selling y The Challenger Sale.\nSi no entiendes esto, el simulador no te va a ayudar.",
  audienceDescription: "KAM · Preventa · Consultores B2B · Nivel intermedio–senior",
  sourcesIntro: "Referencias",
  ctaLabel: "Entender antes de entrar al escenario",
  
  outcome:
    "Diagnostica necesidades, reduce fricción de decisión y desafía la narrativa del cliente sin manipular.",
  sources: [
    {
      author: "Robert Cialdini",
      book: "Influence",
      institution: "Stanford University"
    },
    {
      author: "Neil Rackham",
      book: "SPIN Selling",
      institution: "Huthwaite Research"
    },
    {
      author: "Matthew Dixon & Brent Adamson",
      book: "The Challenger Sale",
      institution: "CEB / Gartner"
    }
  ],
  units: [
    {
      slug: "u1-psicologia",
      order: 1,
      title: "Psicología de la decisión",
      durationMin: 15,
      preAudioPhrase: "Escucha los puntos clave que debes tener en cuenta.",
      objective:
        "Reconocer disparadores psicológicos que aceleran o bloquean decisiones en compras complejas.",
      audioUrl: "/audio/ventas-consultivas-45/u1-psicologia.mp3",
      source: {
        author: "Robert Cialdini",
        book: "Influence"
      },
      bullets: [
        "Las personas no deciden de forma puramente racional",
        "La fricción cognitiva frena el cambio",
        "Influencia es diseño, no presión",
      ],
      apply48h:
        "Reescribe un pitch real de tu trabajo aplicando lo aprendido. Úsalo en tu próxima reunión con cliente.",
      test: {
        questions: [
          "Mis argumentos comerciales asumen que el cliente evalúa de forma objetiva y racional.",
          "Soy consciente de qué principio psicológico estoy activando en cada conversación.",
          "Detecto con claridad cuándo mi discurso genera resistencia en lugar de claridad.",
        ],
        profiles: [
          {
            key: "racional_ingenuo",
            range: [3, 7],
            label: "Racional ingenuo",
            advice: "Refuerza disparadores psicológicos antes de optimizar tu pitch.",
          },
          {
            key: "persuasor_intuitivo",
            range: [8, 11],
            label: "Persuasor intuitivo",
            advice: "Estructura intención: decide qué principio activas y por qué.",
          },
          {
            key: "diseñador_decisiones",
            range: [12, 15],
            label: "Diseñador de decisiones",
            advice: "Consolida consistencia y autoridad como base para diagnóstico SPIN.",
          },
        ],
      },
    },
    {
      slug: "u2-spin",
      locked: true,
      order: 2,
      title: "Diagnóstico real (SPIN)",
      durationMin: 15,
      preAudioPhrase: "Escucha los puntos clave que debes tener en cuenta.",
      objective:
        "Estructurar preguntas que convierten síntomas en urgencia real para el cliente.",
      audioUrl: "/audio/ventas-consultivas-45/u2-spin.mp3",
      source: {
        author: "Neil Rackham",
        book: "SPIN Selling"
      },
      bullets: [
        "La venta compleja se gana diagnosticando, no presentando",
        "Implicación crea urgencia real",
        "Need-payoff cierra con valor, no con presión",
      ],
      apply48h:
        "Diseña 5 preguntas SPIN para tu próxima reunión; 2 deben ser de implicación.",
      test: {
        questions: [
          "Mis reuniones priorizan preguntas por encima de presentaciones.",
          "Hago preguntas que llevan al cliente a verbalizar consecuencias del problema.",
          "Sé guiar al cliente desde síntomas hacia costo de no cambiar.",
        ],
        profiles: [
          {
            key: "informador",
            range: [3, 7],
            label: "Informador",
            advice: "Reduce presentación; aumenta implicación antes de proponer solución.",
          },
          {
            key: "explorador",
            range: [8, 11],
            label: "Explorador",
            advice: "Estandariza tu guion SPIN y mide calidad de preguntas de implicación.",
          },
          {
            key: "arquitecto_problema",
            range: [12, 15],
            label: "Arquitecto de problema",
            advice: "Escala este patrón: documenta tus mejores preguntas y reutilízalas por industria.",
          },
        ],
      },
    },
    {
      slug: "u3-challenger",
      locked: true,
      order: 3,
      title: "Desafiar la narrativa (Challenger)",
      durationMin: 15,
      preAudioPhrase: "Escucha los puntos clave que debes tener en cuenta.",
      objective:
        "Enseñar un insight que reconfigure la perspectiva del cliente sin generar rechazo.",
      audioUrl: "/audio/ventas-consultivas-45/u3-challenger.mp3",
      source: {
        author: "Matthew Dixon & Brent Adamson",
        book: "The Challenger Sale"
      },
      bullets: [
        "Enseñar = crear un marco nuevo",
        "Adaptar = personalizar a la realidad del cliente",
        "Tomar control = liderar tensión productiva",
      ],
      apply48h:
        "Formula un insight en 3 líneas: problema oculto → costo → nueva forma de pensar.",
      test: {
        questions: [
          "Aporto insights que cambian la perspectiva del cliente, no solo datos.",
          "Me siento cómodo generando tensión productiva cuando es necesario.",
          "Sé liderar el cierre con claridad sin ceder el control de la conversación.",
        ],
        profiles: [
          {
            key: "proveedor_reactivo",
            range: [3, 7],
            label: "Proveedor reactivo",
            advice: "Construye un insight por vertical; deja de reaccionar a requerimientos tal cual llegan.",
          },
          {
            key: "consultor_solido",
            range: [8, 11],
            label: "Consultor sólido",
            advice: "Entrena tu teaching pitch y refuérzalo con evidencia y benchmarks.",
          },
          {
            key: "interventor_estrategico",
            range: [12, 15],
            label: "Interventor estratégico",
            advice: "Estandariza tus insights y crea playbooks para replicar este impacto en el equipo.",
          },
        ],
      },
    },
  ],
};
